import { render, staticRenderFns } from "./PersonalInjury.vue?vue&type=template&id=ed141cee"
import script from "./PersonalInjury.vue?vue&type=script&lang=js"
export * from "./PersonalInjury.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports